import { STORAGE_KEYS } from "@/constants";

const isBrowser = () => typeof window !== "undefined";

export const getStoredMaintenanceMessage = () => {
  if (!isBrowser()) {
    return null;
  }

  return window.sessionStorage.getItem(STORAGE_KEYS.MAINTENANCE_MESSAGE);
};

export const setStoredMaintenanceMessage = (message: string | null) => {
  if (!isBrowser()) {
    return;
  }

  if (!message) {
    window.sessionStorage.removeItem(STORAGE_KEYS.MAINTENANCE_MESSAGE);
    return;
  }

  window.sessionStorage.setItem(STORAGE_KEYS.MAINTENANCE_MESSAGE, message);
};

export const clearStoredMaintenanceMessage = () => {
  setStoredMaintenanceMessage(null);
};
